<script setup lang="ts">
defineProps<{
  bestLabel?: string
  worstLabel?: string
  qualityIndex?: number
  worstIcon?: StoryBlokIcon
  bestIcon?: StoryBlokIcon
}>()
const indexColor: { [key: string]: string } = {
  1: '#CC0000',
  2: '#D63333',
  3: '#E06666',
  4: '#F99A34',
  5: '#FAAE5D',
  6: '#FBC285',
  7: '#3BD679',
  8: '#0ACC58',
  9: '#08A346',
  10: '#067A35',
} as const
</script>

<template>
  <div class="flex p-6 flex-col gap-3 self-stretch rounded-xl surface-subdued">
    <div class="flex justify-around gap-1">
      <div v-for="index in Object.keys(indexColor)" class="flex flex-col gap-2 flex-1">
        <div class="self-center text-lg">
          {{ index }}
        </div>
        <div
          class="block h-2 rounded-lg"
          :class="{ 'selected-bar border-primary': qualityIndex === parseInt(index) }"
          :style="{ backgroundColor: indexColor[index] }"
        />
      </div>
    </div>
    <div class="flex justify-between">
      <div class="flex items-center gap-1">
        <AppIcon :size="20" :icon="['far', `${worstIcon?.icon || 'thumbs-down'}`]" />
        <div>{{ worstLabel ? worstLabel : 'Nejhorší' }}</div>
      </div>
      <div class="flex items-center gap-1">
        <AppIcon :size="20" :icon="['far', `${bestIcon?.icon || 'thumbs-up'}`]" />
        <div>{{ bestLabel ? bestLabel : 'Nejlepší' }}</div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.selected-bar {
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  border-width: 1px;
}
.surface-subdued {
  background-color: #EFF2FE;
}
</style>
